import { useEffect, useState, cloneElement } from "react";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../lib/api";

// Gates admin routes: verifies the session server-side, else redirects to login.
export default function RequireAdmin({ children }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getMe()
      .then((u) => {
        if (active) {
          setUser(u);
          setLoading(false);
        }
      })
      .catch(() => navigate("/admin/login", { replace: true }));
    return () => {
      active = false;
    };
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-foreground/70 font-body">
        Loading…
      </div>
    );
  }
  if (!user) return null;
  return cloneElement(children, { user });
}
